export default __webpack_public_path__ + "static/media/506.fa02f874.png";